import React from 'react';
import styled from 'styled-components';
import ClosedTransactionDetail from '../../ClosedTransactionDetail';
import Layout from '../../../components/Layout';

const MainContentWrapper = styled.div`
  padding: 20px;
`;

const TransactionDetail = () => {
  return (
    <Layout>
      <MainContentWrapper>
        <ClosedTransactionDetail />
      </MainContentWrapper>
    </Layout>
  );
  return;
};

export default TransactionDetail;
